import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ROUTE_AMLS_SMART_SCREENING } from '../../constants/globalConstants';
import style from './index.scss';
import {
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/pro-regular-svg-icons';
import { convertISOToDateTimeFormat } from '../../../util/timezone';

import { orderBy } from '../../../util/lodashlike';
export const columnWidth = [101, 261, 236, 83, 157, 94, 138];

const getRowStatus = (record) => {
  if (!record['state']) {
    return '-';
  }
  return record['state'] == 'Approved' || record['state'] == 'Rejected' ? (
    <span
      style={{
        color: record['state'] == 'Approved' ? '#71C969' : '#DF6057'
      }}>
      {record['state']}
    </span>
  ) : (
    <span>{record['state']}</span>
  );
};

const getColumnRender = (
  column,
  record,
  apiActions,
  onRejectIconClickedHanlder
) => {
  switch (column.itemName) {
    case 'id':
      return (
        <div
          onClick={() =>
            apiActions?.navigateTo(
              `${ROUTE_AMLS_SMART_SCREENING}/tickets/${record['id']}`,
              record
            )
          }
          style={{
            fontWeight: '500',
            color: '#0c8ed7',
            cursor: 'pointer'
          }}>
          {record['id'] ? record['id'] : '--'}
        </div>
      );
    case 'state':
      return getRowStatus(record);

    case '':
      return (
        <div>
          {record && record['state'] && record['state'] !== 'Created' ? (
            '-'
          ) : (
            <p style={{ margin: '0px', display: 'flex' }}>
              <span>
                <Tooltip placement="bottom" title="Approve">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    style={{
                      width: '16px',
                      height: '12px',
                      cursor: 'pointer'
                    }}
                    color={'#748AA1'}
                    onClick={() =>
                      apiActions?.putAMLSCommonApproveAndRejectTicket({
                        status: 'Approved',
                        ticketId: record?.id,
                        championName: record?.itemName,
                        runInstanceId: record?.challengerId
                      })
                    }
                  />
                </Tooltip>
              </span>
              <span style={{ marginLeft: '14px' }}>
                <Tooltip placement="bottom" title="Reject">
                  <div className="rejectIcons">
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      style={{
                        width: '16px',
                        height: '12px',
                        cursor: 'pointer'
                      }}
                      color={'#748AA1'}
                      onClick={() => onRejectIconClickedHanlder(record)}
                    />
                  </div>
                </Tooltip>
              </span>
            </p>
          )}
        </div>
      );
  }
  return null;
};

export const columnParser = (
  settings,
  apiActions,
  onRejectIconClickedHanlder
) => {
  let columns = null;
  if (settings) {
    let sortedSettings = orderBy(settings, ['columnIndex'], ['asc']).filter(
      (column) => column.columnVisibility
    );

    columns = sortedSettings.map((setting) => {
      return {
        title: (
          <div className={style.tableHeader}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => (
                <p key={idx} className={style.strong}>
                  {column.itemLabel}
                </p>
              ))}
          </div>
        ),
        width: orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
          .filter((column) => column.visibility)
          .map((column, idx) =>
            column.itemName === 'id' ||
            column.itemName === 'state' ||
            column.itemName === ''
              ? '85px'
              : null
          ),
        render: (text, record) => (
          <div className={style.tableContent}>
            {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
              .filter((column) => column.visibility)
              .map((column, idx) => {
                if (
                  getColumnRender(
                    column,
                    record,
                    apiActions,
                    onRejectIconClickedHanlder
                  ) !== null
                )
                  return getColumnRender(
                    column,
                    record,
                    apiActions,
                    onRejectIconClickedHanlder
                  );
                else if (setting.columnDetail.length >= 2)
                  return (
                    <p key={idx} className={style.mutliRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
                else if (
                  column.itemName == 'createdAt' ||
                  column.itemName == 'updatedAt'
                ) {
                  return (
                    <p key={idx} className={style.singleRecord}>
                      {record[column.itemName]
                        ? convertISOToDateTimeFormat(record[column.itemName])
                        : '--'}
                    </p>
                  );
                } else
                  return (
                    <p key={idx} className={style.singleRecord}>
                      {record[column.itemName] ? record[column.itemName] : '--'}
                    </p>
                  );
              })}
          </div>
        )
      };
    });
  }
  return columns;
};
